import * as React from 'react';
import DefaultTheme from './DefaultTheme';
const ThemeContext = /*#__PURE__*/React.createContext(DefaultTheme);
ThemeContext.displayName = 'ThemeContext';
export default ThemeContext;
//# sourceMappingURL=ThemeContext.js.map